import { call, put, delay } from "redux-saga/effects";
import { userApi } from "@services/api";
import { getAllUsersActions } from "../slices";

function* getAllUsersWorker({ payload }) {
  yield delay(300);
  try {
    yield put(getAllUsersActions.pending());
    const response = yield call(userApi.getAllUsers, payload);
    yield put(getAllUsersActions.success(response));
    // TODO: handle callback | onSuccess
  } catch (error) {
    yield put(getAllUsersActions.failure(error));
    // TODO: handle callback | onFailure
  }
}

export { getAllUsersWorker };
